"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileUploaderConfigurationProvider = exports.FILE_UPLOADER_CONFIGURATION_TOKEN = void 0;
const react_1 = __importDefault(require("react"));
const react_ioc_1 = require("@servicetitan/react-ioc");
exports.FILE_UPLOADER_CONFIGURATION_TOKEN = react_ioc_1.symbolToken('FILE_UPLOADER_CONFIGURATION_TOKEN');
exports.FileUploaderConfigurationProvider = ({ value, children, }) => (react_1.default.createElement(react_ioc_1.Provider, { singletons: [{ provide: exports.FILE_UPLOADER_CONFIGURATION_TOKEN, useValue: value }] }, children));
//# sourceMappingURL=config.js.map